// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c9c8c78","239":"e0575cc0","453":"3442e47a","732":"8504bcea"}[chunkId] + ".chunk.js";
};